import { stock } from '@/data/stockImages';

// Adım adım (S). Hedef: qr kod ile masadan sipariş, masadan sipariş sistemi, qr sipariş.
export default [
  {
    t: 'p',
    text: 'QR kod ile masadan sipariş sisteminde müşteri, masadaki kodu okutup menüyü açar, ürünleri sepete ekler ve siparişi masa numarasıyla gönderir. Sipariş doğrudan işletmenin sistemine düşer; personel onayladıktan sonra hazırlanmaya başlar ve masanın hesabına eklenir. Garsonun sipariş almak için masaya gelmesi gerekmez, ama servis ve kontrol yine personeldedir.',
  },
  {
    t: 'p',
    text: 'Bu yazıda akışı müşteri ve personel tarafından adım adım anlatıyor, kurarken dikkat edilecek noktaları sıralıyoruz. QR menünün kendisi hakkında genel bilgi için [QR menü nedir](/blog/qr-menu-nedir) yazısına bakabilirsiniz.',
  },
  { t: 'h2', text: 'Müşteri tarafında akış' },
  {
    t: 'steps',
    items: [
      {
        title: 'Kodu okutur ve menüyü açar',
        text: 'Telefon kamerası kodu tanır, menü tarayıcıda açılır. Uygulama indirmek ya da üye olmak gerekmez.',
      },
      {
        title: 'Ürünleri sepete ekler',
        text: 'Ürünü seçip adedini belirler. Sepet, siparişi göndermeden önce kontrol edilebilir.',
      },
      {
        title: 'Masa numarasıyla gönderir',
        text: 'Her masada ayrı kod varsa masa numarası otomatik tanınır. Tek kod kullanılıyorsa müşteri masa numarasını kendisi girer.',
      },
      {
        title: 'Onay mesajını görür',
        text: 'Siparişin alındığı ekranda bildirilir. Müşteri isterse daha sonra açık hesabını da menüden görüntüleyebilir.',
      },
    ],
  },
  {
    t: 'guide',
    image: '19-sepet-masa-no',
    alt: 'QR menüde sepet ekranı ve masa numarası girişi',
    caption: 'Sepet: sipariş masa numarasıyla gönderilir.',
  },
  { t: 'h2', text: 'Personel tarafında akış' },
  {
    t: 'p',
    text: 'Menüden gelen siparişin hemen mutfağa gitmemesi bilinçli bir tercihtir. Masa numarası yanlış girilmiş ya da ürün yanlışlıkla iki kez eklenmiş olabilir. Bu yüzden sipariş önce bir onay kuyruğuna düşer:',
  },
  {
    t: 'list',
    ordered: true,
    items: [
      '**Onay Bekliyor:** Sipariş gelir, sorumlu personele bildirim gider. Personel siparişi ve masayı kontrol eder.',
      '**Hazırlanıyor:** Onaylanan sipariş masanın açık hesabına eklenir ve hazırlanmaya başlar.',
      '**Hazır ve Teslim Edildi:** Hazırlanan sipariş servise çıkar, masaya bırakılınca teslim edildi olarak işaretlenir.',
    ],
  },
  {
    t: 'p',
    text: 'Onaylanmayan bir sipariş, iptal nedeni yazılarak iptal edilebilir. Böylece hatalı sipariş hesaba karışmaz ve neden iptal edildiği kayıtta kalır.',
  },
  {
    t: 'guide',
    image: '21-siparis-onay',
    alt: 'Siparişler ekranında onay bekleyen menü siparişi',
    caption: 'Siparişler ekranı: menüden gelen sipariş önce “Onay Bekliyor” sütununa düşer.',
  },
  {
    t: 'guide',
    image: '23-masaya-yansidi',
    alt: 'Onaylanan siparişin masalar ekranında ilgili masanın hesabına eklenmesi',
    caption: 'Onaylanan sipariş masanın açık hesabına eklenir.',
  },
  { t: 'h2', text: 'Kurmadan önce karar verilmesi gerekenler' },
  {
    t: 'img',
    img: stock('masa-qr-standi', 'Kafe masasında QR kodlu sipariş standı'),
  },
  {
    t: 'p',
    text: '**Tek kod mu, masa başına kod mu?** Tek kod basması kolaydır ama müşteri masa numarasını yanlış girebilir. Masa başına kod bu hatayı ortadan kaldırır; karşılığında masalar yer değiştirdiğinde kodların da doğru masaya taşınması gerekir.',
  },
  {
    t: 'p',
    text: '**Bildirim kime gitsin?** Menüden gelen siparişin ilk olarak garsona mı, şef garsona mı düşeceğini belirlemek gerekir. Yoğun saatte bildirimin herkese gitmesi, kimsenin sahiplenmemesine yol açabilir.',
  },
  {
    t: 'p',
    text: '**Hesap menüden görünsün mü?** Müşterinin açık hesabını menüden görmesi, hesap isterken bekleme süresini kısaltır. Bazı işletmeler bunu tercih etmez; ayarın açılıp kapatılabilmesi bu yüzden önemlidir.',
  },
  {
    t: 'p',
    text: '**Masaya bir not:** Kodun yanına “Siparişinizi buradan verebilirsiniz, personelimiz onayladıktan sonra hazırlanır” gibi kısa bir açıklama koymak, özellikle ilk kez kullanan müşterinin kafasındaki soruyu cevaplar.',
  },
  { t: 'h2', text: 'Masadan siparişin işletmeye etkisi' },
  {
    t: 'p',
    text: 'Masadan siparişin en belirgin etkisi, müşterinin garsonu beklediği süreyi azaltmasıdır. İlk sipariş ve özellikle ikinci sipariş (bir içecek daha, tatlı) garsonun o masaya dönmesini beklemeden verilir. Garson da sipariş yazmak yerine servis ve masa takibine daha çok zaman ayırır.',
  },
  {
    t: 'p',
    text: 'Bunun işe yaraması için menünün düzgün hazırlanmış olması gerekir: fotoğraf ve açıklaması olmayan ürünlerde müşteri yine garsona sorar. Hazırlık adımları için [QR menü nasıl oluşturulur](/blog/qr-menu-nasil-olusturulur) yazısına bakabilirsiniz.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da masadan sipariş' },
  {
    t: 'p',
    text: 'Tilki’de online sipariş, “QR Menü” sayfasındaki “Masadan Sipariş Ayarları”ndan açılır. Menüden gelen siparişler “Siparişler” ekranında ve üstteki sepet ikonunda görünür; bildirim, ayarladığınız rollere telefon bildirimi olarak da gider. Akışın tamamı ekran görüntüleriyle [rehberin QR menü bölümünde](/nasil-kullanilir#qr-menu).',
  },
  {
    t: 'cta',
    title: 'Masadan siparişi deneyin',
    text: 'Ücretsiz demo talep edin; kendi menünüzle masadan sipariş akışını birlikte kuralım.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Müşteri yanlış masa numarası girerse ne olur?',
    a: 'Sipariş onay beklerken personel masayı kontrol edip düzeltebilir ya da iptal edebilir. Her masaya ayrı QR kod koymak bu hatayı baştan önler, çünkü masa numarası otomatik tanınır.',
  },
  {
    q: 'Masadan sipariş garsona olan ihtiyacı ortadan kaldırır mı?',
    a: 'Hayır. Sipariş alma kısmı müşteriye geçer, ama onay, servis, masa takibi ve hesap personelde kalır. Garsonun zamanı sipariş yazmaktan servise kayar.',
  },
  {
    q: 'Müşteri menüden ödeme yapabilir mi?',
    a: 'Tilki’de müşteri menüden açık hesabını görebilir, ödeme ise kasada ya da masada personel tarafından kapatılır.',
  },
];
